export class MsalAuthError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "MsalAuthError";
    }
}

export class AcsTokenError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "AcsTokenError";
    }
}

export class EntraTokenCredentialError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "EntraTokenCredentialError";
    }
}
